// 9fbef606107a605d69c0edbcd8029e5d
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import Image from '@tcp/core/src/components/common/atoms/Image';
import ProductRating from '@tcp/core/src/components/features/browse/ProductDetail/molecules/ProductRating/ProductRating';
import PriceCurrency from '@tcp/core/src/components/common/molecules/PriceCurrency';
import Modal from '@tcp/core/src/components/common/molecules/Modal';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getBrand } from '@tcp/core/src/utils/utils';
import styles, { modalStyles } from '../styles/OfferDetails.styles';
import { getIconAsPerBrand, getDateObjectUTCtoPST } from '../../../../../utils/utils';
import { routerPush } from '../../../../../utils/utils.web';
import RichText from '../../../atoms/RichText';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';

const productLink = (pdpUrl, alternateBrand, primaryBrand) => {
  if (pdpUrl.indexOf('/p/') !== -1) {
    if (alternateBrand) {
      routerPush(`/p?pid=${pdpUrl}$brand=${primaryBrand}`, `${pdpUrl}$brand=${primaryBrand}`);
    } else {
      routerPush(`/p?pid=${pdpUrl}`, `${pdpUrl}`);
    }
  } else {
    routerPush(`/b?bid=${pdpUrl?.split('/b/')[1]}`, `${pdpUrl}`);
  }
  return true;
};
const searchLinkClick = (pdpUrl) => {
  routerPush(
    `/search?search/promotional-products/${pdpUrl}`,
    `/search/promotional-products/${pdpUrl}`
  );
  return true;
};

export const shouldDisplayViewAllCta = (count) => count > 6;

export const eligibleItemsExists = (promoProducts) =>
  promoProducts && Object.keys(promoProducts).length;

const OfferIconBlack = () => {
  return (
    <span className="offer-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <circle cx="2.65018" cy="4.94339" r="0.79471" fill="#D9EFFF" />
        <circle cx="4.33153" cy="4.33782" r="0.834404" fill="#D9EFFF" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5635 16.7802L16.7766 11.5671C16.9173 11.4273 16.9965 11.2372 16.9965 11.0388C16.9965 10.8405 16.9173 10.6503 16.7766 10.5105L7.57256 1.30008C7.37355 1.10337 7.0823 1.03239 6.8151 1.11549L2.84959 2.38853C2.61885 2.46675 2.43768 2.64792 2.35947 2.87865L1.08643 6.84416C1.00332 7.11136 1.0743 7.40262 1.27102 7.60162L10.5069 16.7802C10.6467 16.9209 10.8369 17.0001 11.0352 17.0001C11.2336 17.0001 11.4237 16.9209 11.5635 16.7802Z"
          fill="#1A1A1A"
          stroke="#1A1A1A"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.82556 3.82568L0.999882 1"
          stroke="#1A1A1A"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const OfferDetails = ({
  className,
  setOfferDetailsModalActive,
  promo,
  fetchPromoProducts,
  promoProducts,
  setEligibleProducts,
  fetchPromotionsDetails,
  promotionDetails,
  brand,
  couponExpiryTimeDifference,
  fromCartOffers,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const OfferDetailLabels = {
    global: {
      cartItemTile: {
        lbl_best_offers: 'Limited-Time Savings',
        lbl_modalOffer_detail_heading_text: 'Offer Details',
        lbl_modalOffer_eligibleItems: 'ELIGIBLE ITEMS',
        lbl_modalOffer_btm_CTA: 'View All Products',
        lbl_modalOffer_validDate: 'Use by ',
      },
      generic: {
        lbl_tnc: 'Terms & Conditions',
      },
    },
  };
  const headingProps = {
    headingStyle: { className: `modal-heading ${fromCartOffers ? 'align-center' : ''}` },
    hideCloseButton: fromCartOffers,
    isBackButtonShow: fromCartOffers,
  };

  // const expiryDate = getDateObject(promo?.endTime);
  const expiryDate = getDateObjectUTCtoPST(promo?.endTime, true, couponExpiryTimeDifference);

  useEffect(() => {
    const promoId = promo?.redirectionParameter;
    if (promo.redirectionParameter && !fromCartOffers) {
      fetchPromoProducts({ promotionId: promo.redirectionParameter, brand });
    }
    if (!promotionDetails[promoId]) fetchPromotionsDetails(promoId);
  }, [promo]);

  const renderProductRatings = (productInfo, isNewQVEnabled) => {
    const ratings = (productInfo && productInfo.ratings) || 0;
    const reviewsCount = (productInfo && productInfo.reviewsCount) || 0;
    return (
      !!ratings && (
        <div className="ratings-container">
          <ProductRating
            ratings={ratings || 0}
            reviews={reviewsCount}
            isNewQVEnabled={isNewQVEnabled}
          />
        </div>
      )
    );
  };

  const onClose = () => {
    setOfferDetailsModalActive(false);
    setEligibleProducts([]);
  };

  const cartItemTileLabels = getLabelFromCopyOrFromTranslation(
    'global.cartItemTile',
    OfferDetailLabels
  );

  const legalText = promotionDetails[promo?.redirectionParameter]?.legalText;
  const offerDetailsNewText = promotionDetails[promo?.redirectionParameter]?.details;
  const description = promotionDetails[promo?.redirectionParameter]?.description;
  return (
    <>
      <Modal
        fixedWidth
        isOpen
        onRequestClose={() => onClose()}
        overlayClassName="TCPModal__Overlay"
        className={`TCPModal__Content, ${className}`}
        heading={
          fromCartOffers
            ? renderLabel(
                cartItemTileLabels.lbl_modalOffer_detail_heading_text,
                'lbl_modalOffer_detail_heading_text'
              )
            : renderLabel(cartItemTileLabels.lbl_best_offers, 'lbl_best_offers')
        }
        headingAlign="center"
        inheritedStyles={modalStyles}
        headingFontWeight="bold"
        fontSize="fs22"
        headingFontFamily="secondary"
        innerContentClassName={`${
          fromCartOffers
            ? 'offer-details-innerContent from-cart-offers'
            : 'offer-details-innerContent'
        }`}
        isATBModalBackAbTestNewDesign
        {...headingProps}
      >
        <div className="content-wrap">
          <div className="offer-detail-tile">
            <div className="icon-header-wrapper">
              <div className="icon-container">
                {fromCartOffers ? (
                  <OfferIconBlack />
                ) : (
                  <Image
                    src={getIconAsPerBrand()}
                    alt="Special-Offers-Icon"
                    className="icon"
                    width="17.94px"
                    height="17.91px"
                  />
                )}
              </div>
              <div>
                <BodyCopy
                  fontSize={['fs18', 'fs22', 'fs30']}
                  lineHeight={['fs24', 'fs36', 'fs36']}
                  component="p"
                  fontFamily="secondary"
                  className="promotion-message-text"
                  fontWeight="extrabold"
                >
                  {promo?.promotionMessage || description}
                </BodyCopy>

                <BodyCopy
                  fontSize={['fs14', 'fs16', 'fs16']}
                  component="div"
                  fontFamily="secondary"
                  className="promotion-message-validity"
                >
                  {renderLabel(
                    cartItemTileLabels.lbl_modalOffer_validDate,
                    'lbl_modalOffer_validDate'
                  )}
                  {expiryDate
                    ? `${expiryDate.getMonth() + 1}/${expiryDate.getDate()}/${expiryDate
                        .getFullYear()
                        .toString()
                        .substr(-2)}`
                    : ''}
                </BodyCopy>
              </div>
            </div>
          </div>
          {offerDetailsNewText ? (
            <div className="details-wrapper">
              <BodyCopy
                fontSize="fs16"
                component="p"
                fontFamily="secondary"
                className="tnc-heading-text"
                fontWeight="extrabold"
              >
                {renderLabel(
                  cartItemTileLabels.lbl_modalOffer_detail_heading_text,
                  'lbl_modalOffer_detail_heading_text'
                )}
              </BodyCopy>
              <BodyCopy fontSize="fs15" component="p" fontFamily="secondary" fontWeight="semiBold">
                <RichText className="offer-detail-rich-text" richTextHtml={offerDetailsNewText} />
              </BodyCopy>
            </div>
          ) : null}
          {eligibleItemsExists(promoProducts) ? (
            <div className="offer-detail-tile eligible-products">
              <BodyCopy
                fontSize={['fs16', 'fs18', 'fs18']}
                lineHeight={['fs20', 'fs20', 'fs20']}
                component="p"
                fontFamily="secondary"
                className="eligible-items-heading"
                fontWeight="extrabold"
              >
                {renderLabel(
                  cartItemTileLabels.lbl_modalOffer_eligibleItems,
                  'lbl_modalOffer_eligibleItems'
                )}
              </BodyCopy>
              <div className="eligible-items-container">
                {Object.keys(promoProducts).map((product, i) => {
                  if (i <= 5) {
                    const productItem = promoProducts[product];
                    const { imagesByColor, colorsMap, productInfo } = productItem;
                    const { offerPrice, listPrice, pdpUrl, primaryBrand } = productInfo;
                    const imgUrl =
                      imagesByColor[colorsMap[0].color.name]?.basicImageUrl ||
                      `${productInfo?.uniqueId.split('_')[0]}/${productInfo?.uniqueId}.jpg`;
                    const currentBrand = getBrand();
                    const alternateBrand = primaryBrand !== currentBrand.toUpperCase();
                    return (
                      <div
                        className="eligible-item pointer"
                        role="img"
                        tabIndex="-1"
                        aria-label={productInfo?.name}
                      >
                        <div
                          className="product-image-container"
                          onClick={() => {
                            productLink(pdpUrl, alternateBrand, primaryBrand);
                            onClose();
                          }}
                          onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                              productLink(pdpUrl, alternateBrand, primaryBrand);
                              onClose();
                            }
                          }}
                          role="button"
                          tabIndex="0"
                        >
                          <DamImage
                            imgConfigs={['t_plp_img_cat_d', 't_plp_img_cat_d', 't_plp_img_cat_d']}
                            imgData={{
                              alt: 'title',
                              url: imgUrl,
                            }}
                            isProductImage
                            itemBrand={primaryBrand || brand}
                          />
                        </div>
                        <BodyCopy
                          fontFamily="secondary"
                          fontSize="fs16"
                          fontWeight="black"
                          color="red.500"
                        >
                          <PriceCurrency price={productInfo.offerPrice} />
                        </BodyCopy>
                        {offerPrice !== listPrice && (
                          <BodyCopy
                            component="span"
                            color="gray.700"
                            fontFamily="secondary"
                            fontWeight="semibold"
                            fontSize="fs12"
                            className="list-price"
                            textDecoration="line-through"
                          >
                            <PriceCurrency price={listPrice} />
                          </BodyCopy>
                        )}
                        {renderProductRatings(productInfo)}
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
            </div>
          ) : null}
          {legalText && legalText.length ? (
            <div className="terms-and-conditions-wrapper">
              <BodyCopy
                fontSize="fs16"
                component="p"
                fontFamily="secondary"
                className="tnc-heading-text"
                fontWeight="extrabold"
              >
                {getLabelFromCopyOrFromTranslation('global.generic.lbl_tnc', OfferDetailLabels)}
              </BodyCopy>
              <BodyCopy
                fontSize={['fs10', 'fs12', 'fs12']}
                component="p"
                fontWeight="semiBold"
                fontFamily="secondary"
              >
                <RichText className="legal-text-rich-text" richTextHtml={legalText} />
              </BodyCopy>
            </div>
          ) : null}
        </div>
        {shouldDisplayViewAllCta(eligibleItemsExists(promoProducts)) ? (
          <div className="view-all-products-wrapper">
            <div
              onClick={() => {
                searchLinkClick(promo?.redirectionParameter);
                onClose();
              }}
              onKeyDown={() => {
                searchLinkClick(promo?.redirectionParameter);
                onClose();
              }}
              anchorVariation="primary"
              fontFamily="secondary"
              fontWeight="normal"
              fontSizeVariation="medium"
              className="view_all_anchor pointer"
              dataLocator="navigateToCategory"
              role="button"
              tabIndex="0"
            >
              {renderLabel(cartItemTileLabels.lbl_modalOffer_btm_CTA, 'lbl_modalOffer_btm_CTA')}
            </div>
          </div>
        ) : null}
      </Modal>
    </>
  );
};
OfferDetails.propTypes = {
  className: PropTypes.string,
  setOfferDetailsModalActive: PropTypes.func,
  promo: PropTypes.string,
};
OfferDetails.defaultProps = {
  className: '',
  setOfferDetailsModalActive: true,
};

export default withStyles(OfferDetails, styles);
export { OfferDetails as OfferDetailsVanilla };
